export default __webpack_public_path__ + "static/media/logo_decode.f2b77edb.svg";